import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "theme", "onClick", "classes", "namespace"];
import React from 'react';
import classNames from 'classnames/bind';
import { Pencil, PlusLinear } from "../icons";
import { ButtonBase } from "../internal/ButtonBase";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import { themes } from './constants';
import styles from './OrbitButton.css';
var cx = classNames.bind(styles);
var iconTopThemes = [themes.default, themes.add, themes.edit];
var plusThemes = [themes.default, themes.add];
export var OrbitButton = function OrbitButton(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      onClick = _ref.onClick,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      namespace = _ref.namespace,
      props = _objectWithoutProperties(_ref, _excluded);

  var showIconTop = iconTopThemes.includes(theme);
  var shouldShowPlus = plusThemes.includes(theme);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'orbitButton'),
      getTestId = _getMethodsForTestId.getTestId;

  return /*#__PURE__*/React.createElement(ButtonBase, _extends({}, props, getTestId(), {
    className: cx('root', "theme_".concat(theme), classes.root),
    onClick: onClick
  }), children, showIconTop && /*#__PURE__*/React.createElement("span", _extends({
    className: cx('container-icon', classes.containerIcon)
  }, getTestId('container', 'icon')), shouldShowPlus && /*#__PURE__*/React.createElement(PlusLinear, _extends({
    classes: {
      root: cx('icon', classes.icon)
    }
  }, getTestId('icon'))), theme === themes.edit && /*#__PURE__*/React.createElement(Pencil, _extends({
    classes: {
      root: cx('icon', classes.icon)
    }
  }, getTestId('icon')))));
};
export default OrbitButton;